










































_ = require 'lodash'
Prismic = require 'prismic-javascript'
prismic = require '@/utils/prismic/api'
{ textOf } = require '@/utils/prismic/utils'
PrismicDOM = require 'prismic-dom'

module.exports =

		data: ->
				management: []
				office: []

		mounted: ->
				@getPeople()

		methods:
				getPeople: ->
						prismic (api) => api.query(
								Prismic.Predicates.at('document.type', 'contact'),
						).then (response) =>
								_.each response.results, (person) =>
										if person.data.type == "Design/Build"
												@management.push person
										else
												@office.push person




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/home/contact.vue